export default __webpack_public_path__ + "static/media/INCIDENTS-Analytics-2.fb585da2.png";